module.exports = __webpack_public_path__ + "img/grb.731a29f6.svg";